import { render, staticRenderFns } from "./YellowFlag.vue?vue&type=template&id=72d720f8&lang=pug"
import script from "./YellowFlag.vue?vue&type=script&lang=js"
export * from "./YellowFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports